/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: AI 智能看图（标签版）详情弹窗
 * @LastEditors: yingongjing
 * @LastEditTime: 2026-02-28 19:20:48
 */
import './PhotoDetailDialog.scss'
import React from 'react'
import { Modal, Tag } from 'antd'
import { PhotoDetailOutput } from '../hooks/useAITaskEvent'

interface PhotoDetailDialogProps {
  visible: boolean
  photo: PhotoDetailOutput['data'] | null
  onClose: () => void
}

const PhotoDetailDialog: React.FC<PhotoDetailDialogProps> = ({
  visible,
  photo,
  onClose
}) => {
  const isVideo = photo?.media_type === 2

  return (
    <Modal
      open={visible}
      title="照片详情"
      width={1120}
      onCancel={onClose}
      footer={null}
      destroyOnHidden
      mask={{ closable: true }}
      className="photo-detail-modal"
    >
      <div className="photo-detail-dialog">
        {photo ? (
          <div className="photo-detail-container">
            <section
              className="photo-detail-left"
              aria-labelledby="pdd-preview-heading"
            >
              <h3 id="pdd-preview-heading" className="section-title">
                预览
              </h3>
              <div className="preview-section">
                {isVideo ? (
                  <video
                    src={photo.full_url}
                    controls
                    className="preview-media"
                  />
                ) : (
                  <img
                    src={photo.full_url}
                    alt={photo.photo_content || '照片预览'}
                    className="preview-media"
                  />
                )}
              </div>
            </section>

            <section className="photo-detail-right" aria-label="标签列表">
              <div className="detail-card">
                <h3 className="detail-card-header">
                  <span>标签列表</span>
                  <Tag className="detail-card-badge">
                    {photo.tags?.length || 0}
                  </Tag>
                </h3>
                <div className="tags-list">
                  {photo.tags && photo.tags.length > 0 ? (
                    photo.tags.map((tag) => (
                      <div
                        className="tag-item"
                        key={`${tag.tag_type}:${tag.tag_value}`}
                      >
                        <div className="tag-header">
                          <Tag color="blue">
                            {tag.tag_type}: {tag.tag_value}
                          </Tag>
                          {tag.confidence != null && (
                            <Tag color="green">
                              {(tag.confidence * 100).toFixed(1)}%
                            </Tag>
                          )}
                        </div>
                        {tag.reason ? (
                          <div className="tag-reason">原因：{tag.reason}</div>
                        ) : null}
                        {tag.suggestion ? (
                          <div className="tag-suggestion">
                            建议：{tag.suggestion}
                          </div>
                        ) : null}
                      </div>
                    ))
                  ) : (
                    <div className="empty-wrapper">暂无标签</div>
                  )}
                </div>
              </div>
            </section>
          </div>
        ) : (
          <div className="empty-wrapper">照片数据不存在</div>
        )}
      </div>
    </Modal>
  )
}

export default PhotoDetailDialog
